// extracted by mini-css-extract-plugin
export var animationContainer = "_ck-0";
export var asteriskIcon = "_ck-8";
export var conversationLeftSection = "_ck-4";
export var conversationListItem = "_ck-3";
export var conversationMiddleSection = "_ck-5";
export var conversationRightSection = "_ck-6";
export var detailsContent = "_ck-1";
export var listContainer = "_ck-7";
export var modalContent = "_ck-2";